import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import {
  CANCEL_MODAL_TITLE,
  CANCEL_MODAL_MESSAGE,
  CANCEL_MODAL_CONFIRM_BUTTON,
  CANCEL_MODAL_CANCEL_BUTTON
} from "../../global/constants/userDetailsConstants";

const CancelModal = ({ opened, onConfirm, onClose }) => {
  return (
    <Modal
      opened={opened}
      hideCloseButton={false}
      className="modal-confirmation"
      disableOutsideClick={true}
      onClose={onClose}
    >
      <Title size="large" bold primitive="h2" viewport="desktop">
        {CANCEL_MODAL_TITLE}
      </Title>
      <ModalBody>
        <Body size="medium" viewport="desktop" primitive="span">
          <div>
            <p className="modal-confirmation-text">
              {CANCEL_MODAL_MESSAGE}
            </p>
            <ModalFooter
              buttonData={{
                primary: {
                  "data-testid": "userdetails_confirmCancelYesButton",
                  className: "modal-button-width",
                  children: CANCEL_MODAL_CONFIRM_BUTTON,
                  onClick: onConfirm,
                },
                close: {
                  "data-testid": "userdetails_denyCancelNoButton",
                  children: CANCEL_MODAL_CANCEL_BUTTON,
                  className: "modal-button-width",
                  onClick: onClose,
                },
              }}
            />
          </div>
        </Body>
      </ModalBody>
    </Modal>
  );
};

export default CancelModal;
